import {ModuleWithProviders, NgModule} from '@angular/core';
import * as BackOfficeApiClient from './backoffice-api-client';

// @dynamic
export function CreateApiClientConfiguration(token: string, apiUrl: string, apiKey: string = 'ApiKey'): BackOfficeApiClient.ApiClientConfiguration {
  const apiConf = new BackOfficeApiClient.ApiClientConfiguration();
  apiConf.apiKey = apiKey;
  apiConf.apiUrl = apiUrl;
  apiConf.setAuthorizationToken(token);
  return apiConf;
}

@NgModule({
  declarations: [],
  imports: [
  ],
  exports: []
})
export class BackOfficeModule {
  static forRoot(token: string, apiUrl: string, apiKey: string = 'ApiKey'): ModuleWithProviders<BackOfficeModule> {
    return {
      ngModule: BackOfficeModule,
      providers: [
        {
          provide: BackOfficeApiClient.API_BASE_URL,
          useValue: apiUrl
        },
        {
          provide: BackOfficeApiClient.ApiClientConfiguration,
          useFactory: CreateApiClientConfiguration.bind(this, token , apiUrl, apiKey)
        },
      ]
    };
  }
}
